/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import axios from 'axios';
import moment from 'moment';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  handleExistingCommentList,
  handleCommaSeparatedAmount,
  getCommonDropdownList,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeResolutionObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_OBJ,
  screenData: data,
});

// dispatch function for tab data for request current Dispute Display screen
export const dispatchPerformDisputeDetailObj = (data) => ({
  type: actionTypes.GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ,
  detailScrData: data,
});
// dispatch function for tab data for request current Dispute Display screen
export const dispatchDisputedClaimsDetailObj = (data) => ({
  type: actionTypes.GET_DISPUTED_CLAIMS_DETAIL_OBJ,
  payload: data,
});

// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});
//  error msg dispatch function
export const dispatchErrorMsgPerformDis = (data) => ({
  type: actionTypes.GET_ERROR_MSG_PERFORM_DISPUTE_RESOL,
  payload: data,
});
// dispatch display current disputes data from payload
export const dispatchSetDisplayCurrentDisputesPage = (data) => ({
  type: actionTypes.SET_DISPLAY_CURRENT_DISPUTES,
  payload: data,
});

// dispatch disputed claims detail grid
export const dispatchdisputedClaimsDetail = (data) => ({
  type: actionTypes.SET_DISPUTED_CLAIMS_DETAIL,
  payload: data,
});

// dispatch ndc activity history
export const dispatchGetNdcActivityHistory = (data) => ({
  type: actionTypes.SET_NDC_ACTIVITY_HISTORY,
  payload: data,
});

// dispatch provider summary header and grid
export const dispatchProviderSummaryHeaderAndGrid = (data) => ({
  type: actionTypes.SET_PROVIDER_SUMMARY_HEADER_AND_GRID,
  payload: data,
});

// dispatch provider summary header from current disputes screen
export const dispatchProviderSummaryReqHeader = (data) => ({
  type: actionTypes.SET_PROVIDER_SUMMARY_REQ_HEADER,
  payload: data,
});

// dispatch ndc header from current disputes screen
export const dispatchNdcHistoryHeader = (data) => ({
  type: actionTypes.SET_NDC_HISTORY_REQ_HEADER,
  payload: data,
});

// dispatch ndc header from current disputes screen
export const dispatchClaimsDetailHeader = (data) => ({
  type: actionTypes.SET_CLAIMS_DETAIL_REQ_HEADER,
  payload: data,
});

// To dispatch plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM,
  payload: data,
});

//  get rebate programe funnction
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {
      return [];
    });
};

// dispatch quarter value function
export const dispatchQuarterValue = (data) => ({
  type: actionTypes.GET_QUARTER_VALUE,
  payload: data,
});
//  get quarter value data
export const getQuarterValue = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QUARTER_FOR_CONTRACT)
    .then((response) => {
      return dispatch(dispatchQuarterValue(response.data));
    })
    .catch((response) => {
      dispatch(dispatchQuarterValue([]));
    });
};
// dispatch quarter value function
export const dispatchManufacturerValue = (data) => ({
  type: actionTypes.GET_MANUFACTURER_GRID_DATA,
  payload: data,
});
//  get quarter value data
export const getManufacturerDataForGrid = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PDR_MFG_GRID, value)
    .then((response) => {
      return dispatch(dispatchManufacturerValue(response.data));
    })
    .catch((response) => {
      dispatch(dispatchManufacturerValue({ error: 'API failed' }));
    });
};
// dispatch quarter value function
export const dispatchDisplayCurrentDisputes = (data) => ({
  type: actionTypes.GET_DISPLAY_CURRENT_DIPUTES_HEADER_AND_GRID,
  payload: data,
});
export const setDispatchProviderSummaryGrid = (data) => ({
  type: actionTypes.PROVIDER_SUMMARY_GRID_LIST,
  providerSummaryGridList: data,
});
//  get quarter value data
export const getDisplayCurrentDisputes = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DISPLAY_CURRENT_DIPUTES_HEADER_AND_GRID, value)
    .then((response) => {
      const currentDispData =
        response.data.displayDispHeaderAndGridRespVOList.map((val) => {
          const obj = val.currentDisputesGridRespVOList.map((item) => {
            item.numOfUnits = item.numOfUnits
              ? parseFloat(item.numOfUnits).toFixed(4)
              : parseFloat(0).toFixed(4);
            item.disputedUnits = item.disputedUnits
              ? parseFloat(item.disputedUnits).toFixed(4)
              : parseFloat(0).toFixed(4);
            item.paidUnits = item.paidUnits
              ? parseFloat(item.paidUnits).toFixed(4)
              : parseFloat(0).toFixed(4);
            item.unitRebateAmt = item.unitRebateAmt
              ? parseFloat(item.unitRebateAmt).toFixed(4)
              : parseFloat(0).toFixed(4);
            item.dispAmount = item.dispAmount
              ? handleCommaSeparatedAmount(item.dispAmount)
              : `$ ${parseFloat(0).toFixed(2)}`;
            item.interestDue = item.interestDue
              ? handleCommaSeparatedAmount(item.interestDue)
              : `$ ${parseFloat(0).toFixed(2)}`;
            return item;
          });
          return obj;
        });
      return dispatch(dispatchDisplayCurrentDisputes(response.data));
    })
    .catch((response) => {
      dispatch(dispatchDisplayCurrentDisputes([]));
    });
};

//  get disputed claim details grid
export const getDisputedClaimDetailsGrid = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DIPUTED_CLAIM_DETAILS_GRID, value)
    .then((response) => {
      const claimData = response.data.disputedClaimDetails.map((element) => {
        if (element.paidDt) {
          element.paidDt = moment(element?.paidDt).format('MM/DD/YYYY');
        }
        if (element.serviceDt) {
          element.serviceDt = moment(element?.serviceDt).format('MM/DD/YYYY');
        }
        element.reimbursementAmt = element?.reimbursementAmt
          ? `$ ${parseFloat(element?.reimbursementAmt).toFixed(2)}`
          : `$ ${parseFloat(0).toFixed(2)}`;
        element.submittedAmt = element?.submittedAmt
          ? `$ ${parseFloat(element?.submittedAmt).toFixed(2)}`
          : `$ ${parseFloat(0).toFixed(2)}`;
        element.allowedAmt = element?.allowedAmt
          ? `$ ${parseFloat(element?.allowedAmt).toFixed(2)}`
          : `$ ${parseFloat(0).toFixed(2)}`;
        element.tplAmt = element?.tplAmt
          ? `$ ${parseFloat(element?.tplAmt).toFixed(2)}`
          : `$ ${parseFloat(0).toFixed(2)}`;
        element.copayAmt = element?.copayAmt
          ? `$ ${parseFloat(element?.copayAmt).toFixed(2)}`
          : `$ ${parseFloat(0).toFixed(2)}`;
        return element;
      });
      return dispatch(dispatchdisputedClaimsDetail({ response, claimData }));
    })
    .catch((response) => {
      dispatch(dispatchdisputedClaimsDetail([]));
    });
};

//  get NDC activity History
export const getNDCActivityHistory = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_NDC_ACTIVITY_HISTORY, value)
    .then((response) => {
      return dispatch(dispatchGetNdcActivityHistory(response.data));
    })
    .catch((response) => {
      dispatch(dispatchGetNdcActivityHistory([]));
    });
};

//  get provider summary header and grid
export const getProviderSummaryHeaderAndGrid = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_SUMMARY_HEADER_AND_GRID, value)
    .then((response) => {
      const tempObj =
        response.data &&
        response.data?.providerSummaryHeaderRespVO?.providerSummaryGridProviderReviewResponseVO?.map(
          (item, key) => {
            item.isUpdate = false;
            item.key = key;
            item.totalAllowedAmt = `$ ${item.totalAllowedAmt}`;
            item.totalAmtReimbursed = `$ ${item.totalAmtReimbursed}`;
            item.totalAmtSubmitted = `$ ${item.totalAmtSubmitted}`;
            item.pdOfAlw = `${
              item.pdOfAlw ? parseFloat(item.pdOfAlw).toFixed(2) : 0
            } %`;
            item.alwOfSub = `${
              item.alwOfSub ? parseFloat(item.alwOfSub).toFixed(2) : 0
            } %`;
            item.pdOfSub = `${
              item.pdOfSub ? parseFloat(item.pdOfSub).toFixed(2) : 0
            } %`;

            return item;
          }
        );
      return (
        handleExistingCommentList(
          tempObj,
          dispatch,
          setDispatchProviderSummaryGrid
        ),
        dispatch(dispatchProviderSummaryHeaderAndGrid(response))
      );
    })
    .catch(() => {
      dispatch(dispatchProviderSummaryHeaderAndGrid([]));
    });
};

// dispatch quarter value function
export const dispatchProviderSummaryGrid = (data) => ({
  type: actionTypes.GET_PROVIDER_SUMMARY_GRID,
  payload: data,
});

// dispatch provider summary grid Object
export const dispatchProviderSummaryGridObj = (data) => ({
  type: actionTypes.GET_PROVIDER_SUMMARY_GRID_OBJ,
  payload: data,
});

export const dispatchSumOfCount = (data) => ({ 
   type: actionTypes.SUM_OF_COUNT,  payload: data,
   });
// GET Provider Summary Grid API
export const getProviderSummaryGridData = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_PROVIDER_SUMMARY_GRID, value)
    .then((response) => {
      let newObj = [];
      const sumCount = response.data?.providerSummaryGridResp?.sumOfCount;   
      dispatch(dispatchSumOfCount(sumCount));
      const tempObj =
        response.data &&
        response.data?.providerSummaryGridResp?.providerSummaryGridProviderReviewResponseVO?.map(
          (item) => {
            item.isUpdate = false;
            item.isReviewComplite = item.reviewComplete;
            item.isReviewSelect = item.reviewSelect;
            item.reviewComplete =
              parseInt(item.initialReviewComplete, [0, 1]) === 0 &&
              item.reviewSeqNum
                ? 0
                : 1;
            item.reviewSelect = item.initialReviewSelect;
            item.totalAllowedAmt = `$ ${item.totalAllowedAmt}`;
            item.totalAmtReimbursed = `$ ${item.totalAmtReimbursed}`;
            item.totalAmtSubmitted = `$ ${item.totalAmtSubmitted}`;
            item.amtPaidPerUnit = `$ ${
              item.amtPaidPerUnit
                ? parseFloat(item.amtPaidPerUnit).toFixed(2)
                : 0
            } `;
            item.amtPaidForPrescription = `$ ${
              item.amtPaidForPrescription
                ? parseFloat(item.amtPaidForPrescription).toFixed(2)
                : 0
            } `;
            item.pdOfAlw = `${
              item.pdOfAlw ? parseFloat(item.pdOfAlw).toFixed(2) : 0
            } %`;
            item.claimCount = `${item.claimCount ? item.claimCount : 0}`;
            item.totalUnits = `${
              item.totalUnits ? parseFloat(item.totalUnits).toFixed(3) : 0
            }`;
            item.alwOfSub = `${
              item.alwOfSub ? parseFloat(item.alwOfSub).toFixed(2) : 0
            } %`;
            item.pdOfSub = `${
              item.pdOfSub ? parseFloat(item.pdOfSub).toFixed(2) : 0
            } %`;

            return item;
          }
        );
      getCommonDropdownList({
        codeDomainList: ['PROVIDER_ID_TYPE_CD'],
      }).then((res) => {
        if (tempObj?.length > 0) {
          newObj = tempObj.map((item) => {
            const firstDropdownVal = res?.PROVIDER_ID_TYPE_CD?.filter((x) => {
              return (
                x.codeValueID &&
                x.codeValueID?.codeValue === item.providerIdType
              );
            });
            if (firstDropdownVal && firstDropdownVal.length > 0) {
              item.providerIdType = firstDropdownVal[0].shortDescription;
              item.providerIdTypeCd = firstDropdownVal[0]?.codeValueID?.codeValue
            }
            return item;
          });
          handleExistingCommentList(
            newObj,
            dispatch,
            dispatchProviderSummaryGrid
          );
        }
      });
    })
    .catch(() => {
      dispatch(dispatchProviderSummaryGrid([]));
    });
};
// get existing corrlinkIds
export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
// dispatch function for strenght call
export const dispatchStrength = (data) => ({
  type: actionTypes.GET_STRENGTH_DESCR,
  payload: data,
});
//  get strenght decr data call
export const getStrengthDecr = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_STRENGTH_DESCR_DATA, value)
    .then((response) => {
      return dispatch(dispatchStrength(response.data));
    })
    .catch((response) => {
      dispatch(dispatchStrength([]));
    });
};
// dispatch updateProviderSummarySAVE
export const dispatchProviderSummarySave = (data) => ({
  type: actionTypes.UPDATE_PROVIDER_SUMMARY_SAVE,
  payload: data,
});
//  get updateProviderSummarySAVE call
export const getProviderSummarySave = (value) => (dispatch) => {
  if (value === null) {
    dispatch(dispatchProviderSummarySave(null));
  } else {
    return axios
      .post(serviceEndPoint.GET_UPDATE_PROVIDER_SUMMARY_SAVE, value)
      .then((response) => {
        return dispatch(
          dispatchProviderSummarySave({ ...response.data, message: 'SUCCESS' })
        );
      })
      .catch((response) => {
        dispatch(dispatchProviderSummarySave('failed'));
      });
  }
};

// call api for search claims api
export const callSearchClaimAPI = async (values) => {
  try {
    const response = await axios.post(serviceEndPoint.SEARCH_CLAIM, values);
    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};

// DisputedClaimsForReview tab Data
export const saveDisputedClaimsForReviewError = (value) => ({
  type: actionTypes.DISPUTED_CLAIMS_DETAILS_ERROR,
  payload: value,
});

// get save DisputedClaimsForReviewSAVE response
export const saveDisputedClaimsForReviewResponse = (value) => ({
  type: actionTypes.DISPUTED_CLAIMS_DETAILS_SAVE,
  payload: value,
});
//  get updateDisputedClaimsForReviewSAVE call
export const saveDisputedClaimsForReview = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_UPDATE_DISPUTED_CLAIMS_DETAIL_SAVE, value)
    .then((response) => {
      return dispatch(saveDisputedClaimsForReviewResponse(response));
    })
    .catch((response) => {
      dispatch(saveDisputedClaimsForReviewResponse(response));
    });
};
// dispatch fullScrren view for provider summary provider grid
export const dispatchFullScrrenProviderSumm = (data) => ({
  type: actionTypes.FULLSCREEN_SUMM_PRO_GRID,
  payload: data,
});
// dispatch fullScrren view for claims details grid
export const dispatchFullScrrenClaimsDetail = (data) => ({
  type: actionTypes.FULLSCREEN_CLAIM_DETAIL_GRID,
  payload: data,
});
// dispatch save cancel for claims details grid
export const dispatchSaveCancelClaimsDetail = (data) => ({
  type: actionTypes.SAVE_CANCEL_CLAIM_DETAIL,
  payload: data,
});
// dispatch fullScrren view for current disputes details grid
export const dispatchFullScrrenCurrentDisputes = (data) => ({
  type: actionTypes.FULLSCREEN_CURRENT_DISPUTES_GRID,
  payload: data,
});
// dispatch fullScrren view for provider summary Tab data
export const dispatchProviderSummTabData = (data) => ({
  type: actionTypes.PROVIDER_SUMM_TAB_DATA,
  payload: data,
});
// dispatch fullScrren view for NDC History grid
export const dispatchFullScrrenNdcHistory = (data) => ({
  type: actionTypes.FULLSCREEN_NDC_HISTORY_GRID,
  payload: data,
});
// dispatch fullScrren view for NDC History grid
export const dispatchFullScrrenRequestMfgGrid = (data) => ({
  type: actionTypes.FULLSCREEN_REQUEST_MFG_GRID,
  requestScreen: data,
});
// dispatch fullScrren view for NDC History grid
export const dispatchSelectedRowInMfgGrid = (data) => ({
  type: actionTypes.SELECTED_ROW_IN_MFG_GRID,
  payload: data,
});

// dispatch fullScrren view for NDC History grid
export const dispatchCurrentDisputesErr = (data) => ({
  type: actionTypes.DISPUTE_CURRENT_DISPUTE_ERROR,
  payload: data,
});
export const dispatchGetInvoiceHeader = (data) => {
  return {
    type: actionTypes.GET_INVOICE_DETAIL,
    payload: data,
  };
};
// clear redux
export const dispatchPerformDisputeClearRedux = () => (dispatch) => {
  dispatch(dispatchPerformDisputeDetailObj({}));
  dispatch(dispatchRebatePrograme({}));
  dispatch(dispatchPlanType({}));
  dispatch(dispatchQuarterValue({}));
  dispatch(dispatchSetDisplayCurrentDisputesPage({}));
  dispatch(dispatchSelectedRowInMfgGrid({}));
  dispatch(dispatchDisputedClaimsDetailObj({}));
  dispatch(dispatchDisplayCurrentDisputes({}));
  dispatch(dispatchGetInvoiceHeader({}));
};

export const dispatchCurrentDisoutesClearRedux = () => (dispatch) => {
  dispatch(dispatchPerformDisputeDetailObj({}));
  dispatch(dispatchDisplayCurrentDisputes({}));
};

export const getInvoiceHeader = (payload) => (dispatch) => {
  return axios
    .post(serviceEndPoint.ALLOCATE_PAYMENTS_GETINVOICEHEADER, payload)
    .then((response) => {
      return dispatch(
        dispatchGetInvoiceHeader({
          ...response.data?.postInitByInvoiceHeaderResp[0],
          mfgId: payload?.isMFG,
          rebateProgramCd: payload?.isProgramCode,
        })
      );
    })
    .catch((response) => {
      return dispatch(dispatchGetInvoiceHeader(response.data));
    });
};
